export default function InstallBanner({ onInstall, onDismiss }) {
  return (
    <div style={{
      background: '#FFFFFF',
      borderTop: '0.5px solid #E8E4DA',
      padding: '12px 16px',
      display: 'flex',
      alignItems: 'center',
      gap: 12,
    }}>
      <div style={{
        width: 40, height: 40,
        background: '#E6F1FB',
        borderRadius: 10,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        flexShrink: 0,
      }}>
        <img src="/logo-book.png" alt="YOU" style={{ width: 28, height: 28, objectFit: 'contain' }} />
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 13, fontWeight: 500, color: '#2C2C2A', fontFamily: "'Patrick Hand', cursive" }}>
          Add YOU to home screen
        </div>
        <div style={{ fontSize: 11, color: '#888780', fontFamily: "'Inter', sans-serif" }}>
          Open like an app — no browser needed
        </div>
      </div>
      <button onClick={onInstall} style={{
        background: '#448AFF', color: '#FFFFFF', border: 'none', borderRadius: 8,
        padding: '8px 16px', fontSize: 12, fontWeight: 500,
        fontFamily: "'Inter', sans-serif", cursor: 'pointer', flexShrink: 0,
      }}>Install</button>
      <button onClick={onDismiss} style={{
        background: 'none', border: 'none', fontSize: 18, color: '#888780',
        cursor: 'pointer', padding: '0 4px', lineHeight: 1, flexShrink: 0,
      }} aria-label="Dismiss">×</button>
    </div>
  );
}
